import { storeToRefs } from "pinia";
import { watchDebounced } from "@vueuse/core";
import { useOrderStore } from "@/stores";
import { useOrderItemSubscription } from "@/types/graphql";
import type { Unit } from "@/types";

export const useOrderItem = (orderItemId: string) => {
  const store = useOrderStore();
  const { data, error } = useOrderItemSubscription({
    variables: { id: orderItemId },
  });

  watchDebounced(
    data,
    (newData) => {
      if (!newData) return;
      const { orderItem } = newData;
      store.updateOrderItem({
        ...orderItem,
        weighings: orderItem.weighings.map((weighing) => ({
          ...weighing,
          unit: weighing.unit as unknown as Unit, // WeightUnit Enum was added, stuff for another PR
        })),
      });
    },
    { debounce: 500 },
  );

  return {
    ...storeToRefs(store),
    error,
    fetchOrderItem: store.fetchOrder,
  };
};
